import { BaseResponse } from "models/baseResponse";
import { AxiosResponse } from 'axios';
import axiosClient from "./aixosClient";
import serviceType from "constants/serviceType";
import { BankCardAddPayload } from 'models/bankModel';
import { HistoryBetPayload, FundTransSearchPayload, BonusReportSearchPayload} from 'models/fundTransferModel';
import { AgentSignPayload, AgentRegLinkPayload, AgentMemberPayload } from 'models/agentModel';
import { PayloadUpdateUser } from 'models/userInfoModel';
import { StatisticSearchPayload, StatsGeneralResponse, StatsAgencyPayload, StatsDailyPayload } from 'models/statisticModel';
import { WalletHistoryPayload } from 'models/walletModel';
import { PayloadSearchBetRecord } from "models/commonModel";

interface PayloadBasic {
    action?: string;
}

interface PayloadBasic {
    action?: string;
}

const userApi = {
    changeNickname(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'authentication_changeNickname';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    changeBirthday(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'LoginBean_changeBirthday';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    phoneCheck(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personInfo_checkPhone';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    confirmNumPhone(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personInfo_confirmPhone';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    editPassWord(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    //bank api
    getBankPersonList(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personBankCard';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    lockBankCardPerson(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personBankCard_lockBank';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    addBankcardCheckAdd(payload: BankCardAddPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personBankCard_addBank';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    addBankcardCheck(payload: BankCardAddPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personBankCard_addBankCheckPwd';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    //gift code
    sendGiftCode(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'GiftCodeBean_sendGiftCode';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    //agent
    agentRegisterInit(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'agentRegister';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    agentRegisterSave(payload: AgentSignPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'agentRegister_save';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    agentUserSearch(action: 'btnSearch' | 'nextPage', payload: AgentMemberPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `agentUserSearch_${action}`;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    agentUserAutoRegList(payload: { action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'AgentBean_regDomain';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    agentCreateLink(payload: AgentRegLinkPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'agentLinkRegister_save';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    agentTeamBalance(payload: { action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'agentTeamBalance';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    agentUserTeamBalance(payload: { id: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'agentUserSearch_tbalance';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    initAgentZbBean(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'agentBalanceChange_init';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    balanceChangeSearch(payload: FundTransSearchPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'balanceChange_btnSearch';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    bonusReportBean(payload: BonusReportSearchPayload, type: 'btnSearch' | 'nextPage' | 'proPage'): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `bonusReport_${type}`;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    //lịch sử cược
    gameRecordInit(payload: { action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'gameRecord';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    personMessageView(payload: { id: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personMsg_view';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    reportRefundSearch(payload: { depositStatus: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'HtckBean_queryHtck';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    reportRefundMoney(payload: { date: string; gameId: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'HtckBean_payout';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    // thống kê
    reportOverallSearch(payload: StatisticSearchPayload): Promise<AxiosResponse<BaseResponse<StatsGeneralResponse>>> {
        payload.action = 'lotterySaleReport_search';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    reportWinLossSearch(payload: StatsAgencyPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'teamReportWinLoss_bntSearch';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    reportWinLoss2List(payload: StatsDailyPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'teamReportByDay_btnSearch';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    // infor user
    personMessageSearch(payload: { action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'personMsg_btnSearch';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    gameRecordSearch(payload: HistoryBetPayload, type: 'btnSearch' | 'nextPage' | 'proPage'): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `gameRecord_${type}`;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    getFirebaseConfig(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'GetFBConfig';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    //history wallet
    depositSearch(payload: WalletHistoryPayload, type: 'btnSearch' | 'nextPage' | 'proPage'): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `depositSearch_${type}`;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    updateNewUserInfo(payload: PayloadUpdateUser): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'authentication_changeInfo';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    withdrawalSearch(payload: WalletHistoryPayload, type: 'btnSearch' | 'nextPage' | 'proPage'): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `withdrawalSearch_${type}`;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    balance(payload: PayloadBasic): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'balance';
        return axiosClient.post(serviceType.LOTTERY_SERVICE, payload);
    },
    //game record
    lotteryRecordBean(action: 'btnSearch' | 'nextPage' | 'proPage', payload: PayloadSearchBetRecord): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = `gameRecord_${action}`;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    giftCode(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'GiftCodeBean_sendGiftCode';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    getSportViewData(payload: PayloadBasic): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'getSportEvent';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    //config firebase
    configFirebase(payload: PayloadBasic): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'GetFBConfig_get';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
}

export default userApi;